import React, { PropTypes as T } from 'react';
import cn from 'classnames';

export default class Button extends React.Component {
  static propTypes = {
    children: T.node,
    onClick: T.func,
    type: T.string,
    className: T.string,
    href: T.string,
    target: T.string,
    'data-component': T.string,
    primary: T.bool,
    cta: T.bool,
    error: T.bool,
    rounded: T.bool,
    outlined: T.bool,
    disabled: T.bool,
    link: T.bool,
    flex: T.bool,
    icon: T.bool,
    icontext: T.bool,
    nonInteractive: T.bool,
    value: T.string
  };

  static defaultProps = {
    onClick: Function.prototype,
    type: 'button'
  };

  render () {
    const {
      children,
      onClick,
      type,
      className,
      href,
      target,
      primary,
      cta,
      error,
      rounded,
      outlined,
      disabled,
      link,
      flex,
      icon,
      nonInteractive,
      icontext,
      value,
      ...rest
    } = this.props;

    const p = this.props;
    const dataComponent = this.props['data-component'];
    const classNames = cn({
      cButton: true,
      'cButton--primary': p.primary,
      'cButton--cta': p.cta,
      'cButton--rounded': p.rounded,
      'cButton--outlined': p.outlined,
      'cButton--error': p.error,
      'cButton--disabled': p.disabled,
      'cButton--flex': p.flex,
      'cButton--link': p.link,
      'cButton--icon': p.icon,
      'cButton--icontext': p.icontext,
      'cButton--nonInteractive': p.nonInteractive,
      [p.className]: p.className
    });

    if (href) {
      return (
        <a
          {...rest}
          href={href}
          target={target}
          onClick={onClick}
          className={classNames}
          tabIndex={nonInteractive ? -1 : null}
          data-component={dataComponent}
        >
          <div>{children}</div>
        </a>
      );
    }
    else {
      return (
        <button
          {...rest}
          type={type}
          disabled={disabled}
          onClick={onClick}
          className={classNames}
          tabIndex={nonInteractive ? -1 : null}
          data-component={dataComponent}
        >
          <div>{children}</div>
        </button>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/common/button/index.js